<template>
  <md-card class="fullscreen">
    <md-card-media class="fullscreen">
      <!-- swiper -->
      <swiper :options="swiperOption" ref="storyboard" class="fullscreen">

        <swiper-slide v-for="id in 77" :key="id" >
          <img :data-src='"static/movie/1988-" +  (id > 9 ? id : ("0" + id)) + ".png"' class="swiper-lazy" />
          <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
        </swiper-slide>
        
        <!--<div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>-->
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
      </swiper>
    </md-card-media>

    <div class="bg-music">
      <img src="../assets/play.gif" alt="click turn off music" @click="toggleMusic()" v-show="isPlaying"/>
      <img src="../assets/stop.gif" alt="click turn on music" @click="toggleMusic()" v-show="!isPlaying"/>
      <audio id="musicPlayer" v-show="false" src="static/audio/1988.mp3" @canplay="startAutoPlay" autoplay="autoplay" loop="loop"/>    
    </div>
  </md-card>
</template>

<script>
  export default {
    data() {
      return {
        swiperOption: {
          notNextTick: true,
          pagination: '.swiper-pagination',
          paginationClickable: true,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          spaceBetween: 30,
          effect: 'fade',
          autoplay: 1800,
          setWrapperSize :true,
          mousewheelControl : true,
          keyboardControl: true,
          // Disable preloading of all images
          preloadImages: false,
          // Enable lazy loading
          lazyLoading: true
        },
        isPlaying: true
      }
    },
    methods: {
      toggleMusic: function(){
        this.isPlaying ? document.querySelector('#musicPlayer').pause() : document.querySelector('#musicPlayer').play();
        this.isPlaying = !this.isPlaying;
      },
      startAutoPlay: function(){
        this.swiper.startAutoplay();
      }
    },
    computed: {
      swiper() {
        return this.$refs.storyboard.swiper;
      }
    },
    mounted(){
      this.swiper.stopAutoplay();

      //hack for ios safari
      this.$on('touchstart',function(){
        document.querySelector('#musicPlayer').load()
      })
    }
  }
</script>

<style scoped>

  .bg-music{
    position: fixed;
    margin: 10px;
    right: 5%;
    top: 5%;
    width: 20px;
    height: 20px;
    z-index: 999;
  }

  .fullscreen{
    width: 100%;
    height: 100%;
  }

  .swiper-box {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
  .swiper-item {
    height: 100%;
    text-align: center;
    font-size: 18px ;
    background: #fff;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    overflow: hidden;
  }
  .swiper-slide img {
    width: 100%;
    max-width: 100%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 50%;
  }
</style>


// WEBPACK FOOTER //
// Childhood.vue?6f9d4c2b